<template>
  <div id="bg-image">
    <create-new-passcode />
  </div>
</template>

  <script>
  import CreateNewPasscode from '../process/Register/CreateNewPasscode.vue';
    export default {
      name: 'ResetPasscode',
      components: {
        CreateNewPasscode,
      },
    };
  </script>

  <style scoped>

  </style>
